module.exports = __webpack_public_path__ + "static/media/leaderboard.ec958fe2.png";